import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import Grid from '@material-ui/core/Grid';
import ColumnsListDropdown from '../../common/components/ColumnsListDropdown';
import DraggableDialogPaperComponent from '../../common/components/DraggableDialogPaperComponent';
import InjectStore from '../../common/utils/InjectStore';
import ColumnField from '../components/ColumnField';
import ColumnFields from '../components/ColumnFields';
import { FormControlLabel } from '@material-ui/core';
import { Switch } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';

const MapFieldsDialog = (props) => {
  const { store } = props;
  let currentTemplate;

  if (store.currentState != "map-fields") {
    return;
  }

  currentTemplate = store.currentData.templates[store.currentTemplate];
  if (!currentTemplate) {
    return "";
  }
  const handleSave = () => {
    store.handleSave();
  }

  const handleBack = () => {
    store.showEmailCriteriaDialog();
  }

  const handleTemplateSelectionChange = (val, key) => {
    store.handleTemplateSelectionChange(val, key)
  }

  const currentListColumns = TL.list.settings.lookup.CriteriaHelper.formatListColumns(Ext.clone(window.appStore.containerStore.listConfig.listData), window.appStore.containerStore.listConfig.list.name);

  return (
    <div>
      <Dialog
        open={store.currentState == "map-fields"}
        // onClose={handleClose}
        PaperComponent={DraggableDialogPaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth={"md"}
        fullWidth={true}
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          Map Fields
        </DialogTitle>
        <DialogContent >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControlLabel
                value="start"
                control={<Switch
                  checked={currentTemplate.is_multiple_rows}
                  onChange={(ev) => {
                    store.handleCurrentTemplateChange(ev.target.checked, "is_multiple_rows")
                  }}
                // xs={1}
                ></Switch>}
                label="Is Multiple Rows"
                labelPlacement="start"
              />
            </Grid>
            <Grid item xs={12}>
              <ColumnFields
                columns={currentListColumns}
                template={currentTemplate.template}
                subjectTemplate={currentTemplate.subject_template}
                templateSelections={currentTemplate.template_selections}
                value={currentTemplate.fields}
                onChange={(val, key = "fields") => store.handleCurrentTemplateChange(val, key)}
                onTemplateSelectionChange={handleTemplateSelectionChange}
                isMultipleRows={currentTemplate.is_multiple_rows}
                multipleRowsData={currentTemplate.multiple_rows_data}
                handleMultipleRowsDataChange={store.handleMultipleRowsDataChange}
              />
            </Grid>

            {/* <Grid item xs={12}>
                <ColumnsListDropdown label={"Email Subject"} columns={currentListColumns} value={store.currentData.fields.subject} onChange={(val) => handleChange(val, "subject")} />
              </Grid>
              <Grid item xs={12}>
                <ColumnsListDropdown label={"Email Body"} columns={currentListColumns} value={store.currentData.fields.body} onChange={(val) => handleChange(val, "body")} />
              </Grid>
              <Grid item xs={12}>
                <ColumnsListDropdown label={"From"} columns={currentListColumns} value={store.currentData.fields.from} onChange={(val) => handleChange(val, "from")} />
              </Grid> */}
          </Grid>
        </DialogContent>
        <DialogActions>
          {/* {store.isDeleteButtonShown &&
            <Button onClick={store.removeExisting} color="primary">
              Delete existing
          </Button>
          } */}
          <Button onClick={handleBack} color="primary">
            Back
          </Button>
          <Button onClick={store.handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSave} className="save-button-plain">
            {!store.isSaveConfigApiLoading ? "Save" : <CircularProgress />}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default InjectStore(MapFieldsDialog);